<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="title"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="emRepairOrder"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <div v-if="emRepairOrder.pkid ===0 || value === 'deal'|| value === 'edit'">
          <div class="vm-separate">
            <el-form-item label="工单编号">
              <el-input v-model="emRepairOrder.no" disabled placeholder="请输入"/>
            </el-form-item>
            <el-form-item label="故障开始时间">
              <el-date-picker
                  v-model="emRepairOrder.faultTime"
                  disabled
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="设备编号" prop="equipmentCode">
              <el-input v-model="emRepairOrder.equipmentCode" readonly placeholder="选择">
                <el-button
                    slot="append"
                    :disabled="emRepairOrder.status >10"
                    icon="el-icon-search"
                    @click="$refs.selectEquipment.open()"/>
              </el-input>
              <equipment-select ref="selectEquipment" @select="onSelectEquipment"/>
            </el-form-item>
            <el-form-item label="设备名称">
              <el-input v-model="emRepairOrder.equipmentName" readonly placeholder="选择"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="设备型号">
              <el-input v-model="emRepairOrder.equipmentModel" readonly placeholder="选择"/>
            </el-form-item>
            <el-form-item label="位置">
              <el-input v-model="emRepairOrder.equipmentLocation" readonly placeholder="选择"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="销售方">
              <el-input v-model="emRepairOrder.equipmentDealer" readonly placeholder="选择"/>
            </el-form-item>
            <el-form-item label="购入日期">
              <el-input v-model="emRepairOrder.equipmentPurchaseDate" readonly placeholder="选择"/>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="紧急程度">
              <template>
                <el-radio-group v-model="emRepairOrder.urgency" :disabled="emRepairOrder.status >10">
                  <el-radio :label="10">一般</el-radio>
                  <el-radio :label="20">较急</el-radio>
                  <el-radio :label="30">特急</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="质量风险">
              <template>
                <el-radio-group v-model="emRepairOrder.isQualityRisk" :disabled="emRepairOrder.status >10">
                  <el-radio :label="0">不存在</el-radio>
                  <el-radio :label="1">存在</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </div>
          <div class="vm-separate">
            <el-form-item label="可供开始维修时间">
              <el-date-picker
                  v-model="emRepairOrder.availableRepairBeginTime"
                  :disabled="emRepairOrder.status >10"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"/>
            </el-form-item>
            <el-form-item label="可供开始结束时间">
              <el-date-picker
                  v-model="emRepairOrder.availableRepairEndTime"
                  :disabled="emRepairOrder.status >10"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期"/>
            </el-form-item>
          </div>
          <el-form-item label="故障描述" prop="faultDesc">
            <el-input
                v-model="emRepairOrder.faultDesc"
                :disabled="emRepairOrder.status >10"
                type="textarea"
                placeholder="请输入"/>
          </el-form-item>
        </div>
        <div v-if="value === 'deal'">
          <el-form-item label="故障原因">
            <el-input v-model="emRepairOrder.faultReason" type="textarea" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="预防措施">
            <el-input v-model="emRepairOrder.recommendation" type="textarea" placeholder="请输入"/>
          </el-form-item>
          <div class="vm-separate">
            <el-form-item label="是否停机">
              <template>
                <el-radio-group v-model="emRepairOrder.isHalt">
                  <el-radio :label="0">停机</el-radio>
                  <el-radio :label="1">不停机</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="修理方式" prop="repairType">
              <template>
                <el-radio-group v-model="emRepairOrder.repairType" :disabled="emRepairOrder.oaNo!==''">
                  <el-radio :label="10">内修</el-radio>
                  <el-radio :label="20">外修</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </div>
          <el-form-item v-if="emRepairOrder.oaNo" label="OA申请号">
            <el-input v-model="emRepairOrder.oaNo" disabled style="width: 40%" placeholder="请输入"/>
          </el-form-item>
          <div>
            <div slot="toolbar">
              <el-button type="primary" style="margin-bottom: 3%" @click="$refs.repairMethodSelect.open()">
                +选择处理方法
              </el-button>
            </div>
            <repair-method-select ref="repairMethodSelect" @select="repairMethodSelect"/>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
              <el-table-column prop="repairMethodName" align="center" label="处理方法">
                <template slot-scope="scope">
                  <span>{{constant.dealMethod[scope.row.repairMethod]}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="beginTime" align="center" label="开始时间">
                <template slot-scope="scope">
                  <el-date-picker
                      v-model="scope.row.beginTime"
                      type="datetime"
                      :disabled="scope.row.isBackWay===1"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"/>
                </template>
              </el-table-column>
              <el-table-column prop="endTime" align="center" label="结束时间">
                <template slot-scope="scope">
                  <el-date-picker
                      v-model="scope.row.endTime"
                      type="datetime"
                      :disabled="scope.row.isBackWay===1"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"/>
                </template>
              </el-table-column>
              <el-table-column prop="estimatedCost" align="center" label="预估费用">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.estimatedCost" :disabled="scope.row.isBackWay===1" placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column prop="repairmanName" align="center" label="修理人员">
                <template slot-scope="scope">
                  <el-row>
                    <el-col :span="20">
                      <el-input v-model="scope.row.repairMan" :disabled="scope.row.isBackWay===1" placeholder="请输入"/>
                    </el-col>
                    <el-col :span="4">
                      <el-button :disabled="scope.row.isBackWay===1" @click="$refs.repairManSelect.open(scope.$index)">+</el-button>
                    </el-col>
                  </el-row>
                </template>
                <repair-man-select ref="repairManSelect" @select="repairManSelect"/>
              </el-table-column>
              <el-table-column prop="repairContent" align="center" label="维修内容">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.repairContent" :disabled="scope.row.isBackWay===1" placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column
                  label="操作"
                  align="center"
                  class-name="vm-table_operate"
                  width="120px">
                <template slot-scope="scope">
                  <el-button type="info" :disabled="scope.row.isBackWay===1" @click="$refs.editEMRepairOrderWord.open(scope.row.repairContent,scope.$index)">编辑</el-button>
                  <el-button type="danger" :disabled="scope.row.isBackWay===1" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="value === 'confirm'">
          <el-form-item label="修理结果：">
            <template>
              <el-radio-group v-model="emRepairOrder.result">
                <el-radio :label="10">不可使用</el-radio>
                <el-radio :label="20">可以使用</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item v-if="emRepairOrder.isQualityRisk === 1" label="验证方法和结果：">
            <el-input v-model="emRepairOrder.confirmDesc" type="textarea"/>
          </el-form-item>
          <el-form-item v-if="emRepairOrder.unusableDesc!=='' " label="历史描叙：">
            <el-input v-model="emRepairOrder.unusableDesc" disabled type="textarea"/>
          </el-form-item>
          <el-form-item v-if="emRepairOrder.result===10" label="不可使用描叙：">
            <el-input v-model="unusableDesc" type="textarea" placeholder="请输入"/>
          </el-form-item>
          <el-form-item v-if="emRepairOrder.result===10" label="是否继续维修：">
            <template>
              <el-radio-group v-model="emRepairOrder.isOutRepair">
                <el-radio :label="1">继续维修</el-radio>
                <el-radio :label="2">结束维修</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <e-m-repair-order-word-edit ref="editEMRepairOrderWord" @getRepairContent="getRepairContent"/>
  </div>
</template>

<script>

  import EquipmentSelect from "@/views/em/Equipment/EquipmentSelect";
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import RepairMethodSelect from "@/views/em/EMRepairOrder/RepairMethodSelect";
  import RepairManSelect from "@/views/em/EMRepairOrder/RepairManSelect";
  import EMRepairOrderWordEdit from "@/views/em/EMRepairOrder/EMRepairOrderWordEdit";

  export default {
    name:"EMRepairOrderEdit",
    components: {EMRepairOrderWordEdit, RepairManSelect, RepairMethodSelect, EquipmentSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        constant,
        constants,
        value: "",
        title: "",
        unusableDesc: "",
        urgencyType: constant.toSelect(constant.urgencyType),
        faultDealMethod: constant.toSelect(constant.faultDealMethod),
        results: constant.toSelect(constant.result),
        reportOrderStatus: constant.toSelect(constant.reportOrderStatus),
        tableData: [],
        deleteIds: [],
        emRepairOrderDetail: {
          pkid: 0,
          masterId: "",
          repairMethod: "",
          beginTime: "",
          endTime: "",
          repairMan: "",
          estimatedCost: "",
          repairContent: "",
        },
        emRepairOrder: {
          pkid: 0,
          no: "",
          equipmentId: "",
          equipmentName: "",
          equipmentCode: "",
          equipmentModel: "",
          equipmentLocation: "",
          equipmentDealer: "",
          equipmentPurchaseDate: "",
          faultTime: "",
          faultDesc: "",
          availableRepairBeginTime: "",
          availableRepairEndTime: "",
          urgency: 10,
          creatorId: "",
          createTime: "",
          faultReason: "",
          repairType: "",
          recommendation: "",
          result: "",
          unusableDesc: "",
          confirmId: "",
          confirmTime: "",
          confirmDesc: "",
          isOutRepair: 0,
          isQualityRisk: 0,
          isHalt: 0,
          status: "",
          oaNo: "",
          mainRepairMan: "",
          emRepairOrderDetailVOS: [],
        },
        ruleValidate: {
          equipmentCode: {required: true, message: "不能为空", trigger: "blur"},
          repairType: {required: true, message: "不能为空", trigger: "blur"},
          faultDesc: {required: true, message: "不能为空", trigger: "blur"},
          mainRepairMan: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id, val) {
        this.dialogVisible = true;
        this.emRepairOrder.pkid = id;
        this.value = val;
        this.getTitle(val);
        if (id > 0) {
          this.getData();
        } else {
          this.getNo();
        }
      },
      getTitle(val) {
        switch (val) {
          case "edit":
            this.title = "编辑工单";
            break;
          case "deal":
            this.title = "处理工单";
            break;
          case "confirm":
            this.title = "确认工单";
            break;
          default:
            this.title = "新建工单";
        }
      },
      getData() {
        this.$http
          .get("basic", `repairOrders/${this.emRepairOrder.pkid}`)
          .then(resp => {
            console.log(resp.data);
            this.emRepairOrder = resp.data;
            if(this.emRepairOrder.oaNo == null) {
              this.emRepairOrder.oaNo = "";
            }
            this.tableData = this.emRepairOrder.emRepairOrderDetailVOS;
            console.log(this.emRepairOrder);
          });
      },
      getNo() {
        this.$http
          .get("basic", "repairOrders/getEMRepairOrderNo")
          .then(resp => {
            console.log(resp);
            this.emRepairOrder.no = resp.data;
          });
      },
      getRepairContent(val,index) {
        console.log(val,index);
        this.tableData[index].repairContent = val;
      },
      onSelectEquipment(row) {
        this.emRepairOrder.equipmentId = row.pkid;
        this.emRepairOrder.equipmentCode = row.no;
        this.emRepairOrder.equipmentName = row.name;
        this.emRepairOrder.equipmentModel = row.model;
        this.emRepairOrder.equipmentLocation = row.location;
        this.emRepairOrder.equipmentDealer = row.dealer;
        this.emRepairOrder.equipmentPurchaseDate = row.purchaseDate;
      },
      repairMethodSelect(row) {
        // for (let item of this.tableData) {
        //   if (item.repairMethod === row.id) {
        //     this.$message.error("不能重复添加同一种方法");
        //     return;
        //   }
        // }
        this.tableData.push({
          repairMethod: row.id,
          repairMethodName: row.repairMethodName,
          beginTime: "",
          endTime: "",
          estimatedCost: "",
          repairMan: "",
          repairContent: "",
        });
      },
      repairManSelect(row) {
        if (this.tableData[row.index].repairMan === "") {
          this.tableData[row.index].repairMan = row.dealMan;
        } else {
          this.tableData[row.index].repairMan += "," + row.dealMan;
        }
      },
      oneDelete(index, row) {
        this.tableData.splice(index, 1);
        if (row.pkid) {
          this.deleteIds.push(row.pkid);
        }
      },
      //数据库真正删除
      delete() {
        this.$http
          .delete("basic", "repairOrderDetails/idList", this.deleteIds).then(() => {
            this.deleteIds = [];
          });
      },
      handleSubmit() {
        console.log(this.deleteIds);
        if (this.deleteIds.length > 0) {
          this.delete();
        }
        if (this.value === "edit") {
          this.handleSubmitUpData();
        } else if (this.value === "deal") {
          this.emRepairOrder.emRepairOrderDetailVOS = this.tableData;
          this.handleSubmitDealData();
        } else if (this.value === "confirm") {
          console.log(this.emRepairOrder);
          if (this.emRepairOrder.isQualityRisk === 1 && this.emRepairOrder.confirmDesc ==="") {
            return this.$message.error("此情况验证方法和结果必填！");
          }
          this.emRepairOrder.unusableDesc = this.unusableDesc;
          this.handleSubmitConfirmData();
        } else {
          this.handleSubmitSave();
        }
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "repairOrders", this.emRepairOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "repairOrders/edit", this.emRepairOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitDealData() {
        if (this.emRepairOrder.emRepairOrderDetailVOS.length === 0) {
          return this.$message.error("请添加处理方法");
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "repairOrders/deal", this.emRepairOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitConfirmData() {
        console.log(this.emRepairOrder.result);
        if (this.emRepairOrder.result === 20) {
          this.emRepairOrder.unusableDesc = "";
          this.emRepairOrder.isOutRepair = "";
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "repairOrders/confirm", this.emRepairOrder)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
                this.unusableDesc = "";
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
